import React from 'react';
import { Grid } from '@mui/material';
import FunctionCard from './FunctionCard';

// The column every page of function cards is laid out in. Exported because the
// AI page puts a heading block above its cards that has to line up with them
// but is not itself a card — it used to borrow this container with an empty
// `items`, which meant rendering a heading through a card list.
export const FUNCTION_CARD_COLUMN = {
  maxWidth: 635,
  width: '100%',
  margin: 'auto',
  // v4 Grid spacing={2} applied padding:8px to each item (negative margin on
  // the container compensated at edges, but inline margin:'auto' already
  // cancelled that).  v9 Grid v2 uses CSS gap instead — items lose their
  // individual padding.  Restore edge padding so cards have breathing room.
  padding: '4px 16px'
};

const FunctionCardsContainer = props => {
  const { prepend, items = [], append } = props;

  return (
    <Grid container spacing={2} style={FUNCTION_CARD_COLUMN}>
      {prepend && <Grid size={12}>{prepend}</Grid>}
      {items.map((item, index) => {
        return item && !item.disabled ? (
          <Grid size={12} key={index}>
            <FunctionCard key={index} {...item} />
          </Grid>
        ) : null;
      })}
      {append && <Grid size={12}>{append}</Grid>}
    </Grid>
  );
};

export default FunctionCardsContainer;
